module.exports = __webpack_public_path__ + "img/daruebereinfuegen.1a7167b.svg";